module.exports = __webpack_public_path__ + "img/logo.ac56ad9e.png";